const gitlabLink = "https://gitlab.com/arielvia2013";
const youtubeChannelLink = "https://www.youtube.com/channel/UCp2Hd-biIKym7-b9EqKVq3g";
const linkedinLink = "https://www.linkedin.com/in/juan-ariel-via-meneces/";
const mailLink = "mailto:arielvia2013@gmail.com";
const gitHubLink = "https://github.com/juanAriel";

export { gitlabLink, youtubeChannelLink, linkedinLink, mailLink, gitHubLink };
